import React, { useState } from "react";
import "../styles.css";
import MovieCard from "./MovieCard";

const API_KEY = process.env.REACT_APP_TMDB_API_KEY;

export default function MoviesGrid({
  movies,
  setMovies, // ✅ we’ll need this from parent
  watchlist,
  toggleWatchlist,
  genres = {},
  loadMoreMovies,
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [genre, setGenre] = useState("All Genres");
  const [rating, setRating] = useState("All");

  // 🔍 Search TMDB directly
  const handleSearchChange = async (e) => {
    const term = e.target.value;
    setSearchTerm(term);

    if (term.trim() === "") {
      // reset back to popular movies
      loadMoreMovies(1);
      return;
    }

    try {
      const response = await fetch(
        `https://api.themoviedb.org/3/search/movie?api_key=${API_KEY}&language=en-US&query=${term}`
      );
      const data = await response.json();
      setMovies(data.results || []);
    } catch (err) {
      console.error("Error searching movies:", err);
    }
  };

  const matchesGenre = (movie, genre) => {
    if (genre === "All Genres") return true;
    return movie.genre_ids?.some((id) => genres[id] === genre);
  };

  const matchesRating = (movie, rating) => {
    switch (rating) {
      case "All":
        return true;
      case "Good":
        return movie.vote_average >= 8;
      case "Ok":
        return movie.vote_average >= 5 && movie.vote_average < 8;
      case "Bad":
        return movie.vote_average < 5;
      default:
        return false;
    }
  };

  const filteredMovies = movies.filter(
    (movie) => matchesGenre(movie, genre) && matchesRating(movie, rating)
  );

  return (
    <div>
      <input
        type="text"
        className="search-input"
        placeholder="Search movies..."
        value={searchTerm}
        onChange={handleSearchChange}
      />

      <div className="filter-bar">
        <div className="filter-slot">
          <label>Genre</label>
          <select
            className="filter-dropdown"
            value={genre}
            onChange={(e) => setGenre(e.target.value)}
          >
            <option>All Genres</option>
            {genres &&
              Object.values(genres).map((g) => <option key={g}>{g}</option>)}
          </select>
        </div>

        <div className="filter-slot">
          <label>Rating</label>
          <select
            className="filter-dropdown"
            value={rating}
            onChange={(e) => setRating(e.target.value)}
          >
            <option>All</option>
            <option>Good</option>
            <option>Ok</option>
            <option>Bad</option>
          </select>
        </div>
      </div>

      <div className="movies-grid">
        {filteredMovies.map((movie) => (
          <MovieCard
            movie={movie}
            key={movie.id}
            toggleWatchlist={toggleWatchlist}
            isWatchlisted={watchlist.includes(movie.id)}
            genres={genres}
          />
        ))}
      </div>

      {searchTerm === "" && (
        <div style={{ textAlign: "center", margin: "20px 0" }}>
          <button className="watchlist-btn" onClick={loadMoreMovies}>
            Load More
          </button>
          <button
            className="watchlist-btn"
            style={{ marginLeft: "10px" }}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            Back to Top
          </button>
        </div>
      )}
    </div>
  );
}
